import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { UnstyledLink, HomepageCard } from '../utils/styles'
import HomepageHero from '../components/HomepageHero';

const IndexPage = (props) => {
  return (
    <div css={{ paddingBottom: 60 }}>
      <HomepageHero />

      <Link className={UnstyledLink} to="/portfolio">
        <article className={HomepageCard}>
          <Img sizes={props.data.portfolioImg.childImageSharp.sizes} />
          <h2>Explore<small>My work</small></h2>
        </article>
      </Link>

      <Link className={UnstyledLink} to="/about">
        <article className={HomepageCard}>
          <Img sizes={props.data.aboutImg.childImageSharp.sizes} />
          <h2>Learn more<small>About me</small></h2>
        </article>
      </Link>
    </div>
  )
}

export default IndexPage

export const query = graphql`
  query HomepageImages {
    portfolioImg: file(relativePath: { eq: "portfolio.jpg" } ) {
      childImageSharp {
        sizes(maxWidth: 1920, maxHeight: 1080, quality: 90, traceSVG: { color: "#021212" }) {
          ...GatsbyImageSharpSizes
        }
      }
    }
    aboutImg: file(relativePath: { eq: "about.jpg" } ) {
      childImageSharp {
        sizes(maxWidth: 1920, maxHeight: 1080, quality: 90, traceSVG: { color: "#021212" }) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js